import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "welcome full centered" };
const _hoisted_2 = { class: "anchor-bottom centered" };
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WelcomePage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "slide1" }, null, -1)),
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Money Guided", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Feel good financial outcomes", -1)),
                    _createVNode(MGButton, {
                        text: "Continue",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push({ path: 'getstarted' })))
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-3 centered" }, [
                        _createTextVNode("Already have an account? "),
                        _createElementVNode("a", { href: "/#/login" }, "Sign in")
                    ], -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "small centered" }, "Money Guided is a registered company in England & Wales registered number 11713082.", -1))
                ])
            ]));
        };
    }
});
